/* eslint-disable */
import ReactDOM from "react-dom";
import "../styles/ImageGalleryModal.css";
import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

interface Zona {
  nombre: string;
  label?: string;
  descripcion?: string;
  imagenes: string[];
}

interface Props {
  images: string[];
  currentIndex: number;
  onClose: () => void;
  setIndex: (index: number) => void;
  zonas: Zona[];
  modalActiveTab: string;
  setModalActiveTab: (nombre: string) => void;
}

function ImageGalleryModal({
  currentIndex,
  onClose,
  setIndex,
  zonas,
  modalActiveTab,
  setModalActiveTab,
}: Props) {
  const [displayedTab, setDisplayedTab] = useState(modalActiveTab);
  const [isFading, setIsFading] = useState(false);
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);
  const isMobile = window.innerWidth < 768;

  const zona = zonas.find((z) => z.nombre === displayedTab);

  const handleTabSwitch = (zonaNombre: string) => {
    if (zonaNombre === displayedTab) return;
    setIsFading(true);
    setTimeout(() => {
      setDisplayedTab(zonaNombre);
      setIndex(0);
      setIsFading(false);
      setModalActiveTab(zonaNombre);
    }, 250);
  };

  const minSwipeDistance = 50;
  const handleSwipe = () => {
    if (!touchStart || !touchEnd || !zona) return;
    const distance = touchStart - touchEnd;
    if (distance > minSwipeDistance) {
      setIndex((currentIndex + 1) % zona.imagenes.length);
    } else if (distance < -minSwipeDistance) {
      setIndex(
        (currentIndex - 1 + zona.imagenes.length) % zona.imagenes.length
      );
    }
    setTouchStart(null);
    setTouchEnd(null);
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";
    return () => {
      document.body.style.overflow = "auto";
      document.body.style.touchAction = "auto";
    };
  }, []);

  return ReactDOM.createPortal(
    <div className="gallery-modal-overlay" onClick={onClose}>
      <div
        className="gallery-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-btn" onClick={onClose}>
          ×
        </button>

        <div className="zona-selector-wrapper">
          <div className="modal-sidebar">
            {zonas.map((zona) => (
              <div
                key={zona.nombre}
                className={`sidebar-item ${
                  zona.nombre === displayedTab ? "active" : ""
                }`}
                onClick={() => handleTabSwitch(zona.nombre)}
              >
                {zona.label || zona.nombre}
              </div>
            ))}
          </div>

          <select
            className="zona-select"
            value={displayedTab}
            onChange={(e) => handleTabSwitch(e.target.value)}
          >
            {zonas.map((zona) => (
              <option key={zona.nombre} value={zona.nombre}>
                {zona.label || zona.nombre}
              </option>
            ))}
          </select>
        </div>

        <div
          className={`modal-zona-content ${isFading ? "fade-out" : "fade-in"}`}
          style={{ margin: "0 auto" }}
        >
          <div className="zona-descripcion-modal">
            {!isMobile && <h3>{zona?.label}</h3>}
            <p>{zona?.descripcion}</p>
          </div>

          <div
            className="main-image-wrapper"
            onTouchStart={(e) => setTouchStart(e.touches[0].clientX)}
            onTouchMove={(e) => setTouchEnd(e.touches[0].clientX)}
            onTouchEnd={handleSwipe}
          >
            {!isMobile && (
              <button
                className="arrow left"
                onClick={() =>
                  setIndex(
                    (currentIndex - 1 + (zona?.imagenes.length || 1)) %
                      (zona?.imagenes.length || 1)
                  )
                }
              >
                <ChevronLeft />
              </button>
            )}

            <img
              src={zona?.imagenes[currentIndex % (zona?.imagenes.length || 1)]}
              className="main-image"
              alt=""
            />

            {!isMobile && (
              <button
                className="arrow right"
                onClick={() =>
                  setIndex((currentIndex + 1) % (zona?.imagenes.length || 1))
                }
              >
                <ChevronRight />
              </button>
            )}
          </div>

          <div className="thumbnails-container">
            <div className="thumbnails-scroll">
              <div className="thumbnails">
                {zona?.imagenes.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt=""
                    className={`thumb ${i === currentIndex ? "active" : ""}`}
                    onClick={() => setIndex(i)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ImageGalleryModal;
